import { useState } from 'react';
import * as React from 'react';
import { Alert, Button, List, PageHeader, Popconfirm, Typography, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { UploadChangeParam } from 'antd/es/upload';
import * as XLSX from 'xlsx';
import api from '@/api';
import { useHistory } from 'react-router';
import { API_COMPANY_CAR, PATH_COMPANY_CAR } from '@/constants/constant';

const CompanyCarImportPage: React.FC = () => {
  const history = useHistory();
  const [uploadError, setUploadError] = useState('');
  const [plateNoList, setPlateNoList] = useState<string[]>([]);
  const onChange = (info: UploadChangeParam) => {
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      const bstr = e?.target?.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });

      const plateNoArr: string[] = [];

      wb.SheetNames.forEach((item) => {
        console.log(wb.Sheets[item]);
        const sheetJson = XLSX.utils.sheet_to_json<Record<string, unknown>>(wb.Sheets[item], { raw: true, defval: null });
        sheetJson.forEach((row) => {
          Object.entries(row).forEach(([key, value]) => {
            if (key === '차량번호') {
              plateNoArr.push(value as string);
            }
          });
        });
      });

      setPlateNoList(plateNoArr);
    };

    if (rABS) {
      if (info.file.originFileObj) reader.readAsBinaryString(info.file.originFileObj);
    } else if (info.file.originFileObj) reader.readAsArrayBuffer(info.file.originFileObj);
  };
  return (
    <PageHeader
      title="차량 복원"
      subTitle="기존 차량 목록을 복원합니다."
      style={{ background: '#fff', border: '1px solid rgb(235, 237, 240)' }}
      onBack={() => window.history.back()}
    >
      <Upload
        onChange={onChange}
        accept=".xls,.xlsx,.csv"
        onRemove={() => {
          setPlateNoList([]);
        }}
      >
        <Button>
          <UploadOutlined /> Click to Upload
        </Button>
      </Upload>
      {plateNoList.length > 0 && (
        <>
          <Popconfirm
            title="등록하시겠습니까?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              const data = plateNoList.map((value) => ({ plateNo: value, companyId: 1 }));
              api
                .post(API_COMPANY_CAR, 'pcompany.PbCompanyCarCreateRequest', {
                  car: data,
                })
                .then((res) => {
                  history.replace(PATH_COMPANY_CAR);
                })
                .catch((e) => {
                  setUploadError(e.response.data.message);
                });
            }}
          >
            <Button>등록</Button>
          </Popconfirm>
          {uploadError && <Alert message={uploadError} type="error" />}
          <List
            style={{ marginTop: '20px' }}
            header={<Typography.Text strong>차량번호 목록</Typography.Text>}
            footer={`총 : ${plateNoList.length} 대`}
            bordered
            size="small"
          >
            {plateNoList.map((plateNo) => {
              return (
                <List.Item>
                  <Typography.Text>{plateNo}</Typography.Text>
                </List.Item>
              );
            })}
          </List>
        </>
      )}
    </PageHeader>
  );
};

export default CompanyCarImportPage;
